import * as React from "react";

import {ClipsFullscreenStore} from "../../../lib/ClipsFullscreenStore";
import {Toast, ToastAlignment} from "@ok/web/components/base/Toast/Toast";

import {UniCell} from "@ok/common/design-system/components/UniCell";
import {LazyIcon} from "@ok/web/components/base/Icon/LazyIcon";
import {IconSizes, IIconSize} from "@ok/web/components/base/Icon/lib/iconHelpers";
import {ContentsView} from "@ok/common/design-system/components";
import {Content} from "@ok/common/design-system/components/Content";
import {Button} from "@ok/common/design-system/components/Button";
import {ToastType} from "../../../lib/types";

import classes from "../../ClipsFullscreen/ClipsFullscreen.styl";
import {DELETION_TIMEOUT} from "../../../config";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

export function getToast(type: ToastType | null, store: ClipsFullscreenStore) {
    if (type === null) {
        return;
    }

    let style;
    if (type === ToastType.DISLIKED) {
        style = {
            "animationDelay": DELETION_TIMEOUT + "ms"
        };
    }

    return (
        <Toast alignment={ToastAlignment.BOTTOM} className={classes["toast-reset"]} style={style}>
            <UniCell data-tsid={" "}
                     view={"primary"}
                     customVarsStyles={classes["reset"]}
            >
                {getLeft(type)}
                {getMiddle(type, store)}
            </UniCell>
        </Toast>
    );
}


function getLeft(type: ToastType) {
    let result = null;

    switch (type) {
        case ToastType.SUBSCRIBED:
        case ToastType.RESHARE_SUCCESS: {
            result = (
                <UniCell.Left>
                    <LazyIcon name={"DONE_BUBBLE"} size={IconSizes["16"] as IIconSize}/>
                </UniCell.Left>
            );

            break;
        }

        case ToastType.LOAD_ERROR: {
            result = (
                <UniCell.Left>
                    <LazyIcon name={"ALERT_CIRCLE_24"} size={IconSizes["24"] as IIconSize}/>
                </UniCell.Left>
            );

            break;
        }

        default: {

        }
    }

    return result;
}


function getMiddle(type: ToastType, store: ClipsFullscreenStore) {
    let result = null;

    switch (type) {
        case ToastType.SUBSCRIBED:
        case ToastType.RESHARE_SUCCESS:
        case ToastType.LINK_COPIED: {
            let text;

            if (type === ToastType.SUBSCRIBED) {
                text = l10NPkg.getLMsg("subscribed");
            } else if (type === ToastType.RESHARE_SUCCESS) {
                text = l10NPkg.getLMsg("clipReshared");
            } else if (type === ToastType.LINK_COPIED) {
                text = l10NPkg.getLMsg("linkCopied");
            }

            result = (
                <UniCell.Middle>
                    <ContentsView>
                        <ContentsView.Row>
                            <ContentsView.Content>
                                <Content.Text>
                                    {text}
                                </Content.Text>
                            </ContentsView.Content>
                        </ContentsView.Row>
                    </ContentsView>
                </UniCell.Middle>
            );
            break;
        }

        case ToastType.DISLIKED: {
            result = (
                <UniCell.Middle>
                    <ContentsView>
                        <ContentsView.Row>
                            <ContentsView.Content>
                                <Content.Text>
                                    <div className={classes["toast__text"]}>
                                        {l10NPkg.getLMsg("disliked")}
                                    </div>
                                </Content.Text>
                            </ContentsView.Content>
                        </ContentsView.Row>
                        <ContentsView.Row>
                            <ContentsView.Content>
                                <Button
                                    data-tsid={" "}
                                    aria-label={l10NPkg.getLMsg("abortDislike")}
                                    view={"primary-on-color"}
                                    size={"28"}
                                    onClick={() => {
                                        store.abortDeletion();
                                    }}
                                >
                                    <Button.Label>
                                        {l10NPkg.getLMsg("cancel")}
                                    </Button.Label>
                                </Button>
                            </ContentsView.Content>
                        </ContentsView.Row>
                    </ContentsView>
                </UniCell.Middle>
            );

            break;
        }

        case ToastType.LOAD_ERROR: {
            result = (
                <UniCell.Middle>
                    <ContentsView>
                        <ContentsView.Row >
                            <ContentsView.Content>
                                <Content.Text view={"primary"} size={"15"}>
                                    {l10NPkg.getLMsg("loadError")}
                                </Content.Text>
                            </ContentsView.Content>
                        </ContentsView.Row>
                        <ContentsView.Row >
                            <ContentsView.Content>
                                <Content.Text view={"secondary"} size={"13"}>
                                    {l10NPkg.getLMsg("loadErrorSuggest")}
                                </Content.Text>
                            </ContentsView.Content>
                        </ContentsView.Row>
                    </ContentsView>
                </UniCell.Middle>
            );

            break;
        }

        default: {

        }
    }

    return result;
}
